"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/focusable/focusable-context.tsx
var _react = require('react');
var FocusableContext = _react.createContext.call(void 0, true);



exports.FocusableContext = FocusableContext;
